import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { isMobile, isMobileXL } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class HomeComponent implements OnInit {
  public Bayer: string
  public Nombre: string
  rippleColor: string = 'red';
  public Etiquetas: {
    IconoADM: string,
    IconoTablas: string,
    arialabel: string,
    FooterText: string,
    HeaderImage1: string,
    HeaderImage2: string,
    HeaderText: string,
    HeroImage1: string,
    HeroText2: string,
    HeroText3: string,
    Ayuda1: string;
    Ayuda2: string;
    MailContacto: string

  }

  constructor(private configService: ConfigService,
    private loggedService: LoggedService,
    private router: Router,
    private snackBarService: SnackbarService,
    private sidenav: SidenavService) {
  }


  ngOnInit() {

    this.Bayer = this.configService.uri.Bayer
    if (this.isLogged()) {
      this.Nombre = this.loggedService.logged.nombre;
      this.loggedService.cModulosSideNav();
    }
    //console.log(this.loggedService.logged);
    this.Etiquetas = {
      arialabel: this.configService.etiquetas.Home.arialabel,
      Ayuda1: this.configService.etiquetas.Home.Ayuda1,
      Ayuda2: this.configService.etiquetas.Home.Ayuda2,
      FooterText: this.configService.etiquetas.Home.FooterText,
      HeaderImage1: this.configService.etiquetas.Home.HeaderImage1,
      HeaderImage2: this.configService.etiquetas.Home.HeaderImage2,
      HeaderText: this.configService.etiquetas.Home.HeaderText,
      HeroImage1: this.configService.etiquetas.Home.HeroImage1,
      HeroText2: this.configService.etiquetas.Home.HeroText2,
      HeroText3: this.configService.etiquetas.Home.HeroText3,
      IconoADM: this.configService.etiquetas.IconoADM,
      IconoTablas: this.configService.etiquetas.IconoTablas,

      MailContacto: this.configService.etiquetas.MailContacto,
    }


  }
  test() {
    this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 2, 2);
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }
  isMobile() {
    return isMobile();
  }
  isMobileXL() {
    return isMobileXL();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

  toggleRightSidenav() {
    this.sidenav.toggle();
  }

}
